import { AgeRange, Gender } from '../redux/profile';
import { Api } from './api';

export class ProfilesApi {
    private static readonly PATH = '/profiles';

    constructor(private readonly m_api: Api) {}

    public async getProfile() {
        return this.m_api.get(`${ProfilesApi.PATH}`);
    }

    public async setProfile(gender: Gender, ageRange: AgeRange) {
        return this.m_api.post(`${ProfilesApi.PATH}/set-profile`, { gender, ageRange });
    }

    public async setGender(gender: Gender) {
        return this.m_api.post(`${ProfilesApi.PATH}/set-gender`, { gender });
    }

    public async setAgeRange(ageRange: AgeRange) {
        return this.m_api.post(`${ProfilesApi.PATH}/set-age-range`, { ageRange });
    }
}